import React from 'react';
import { TextV2 } from '@withjoy/joykit';
import { useTranslation } from '@shared/core';
import { pxToRem } from '@withjoy/joykit/theme';

type PercentageOffBadgeProps = {
  percentage: number;
};

export const PercentageOffBadge = ({ percentage }: PercentageOffBadgeProps) => {
  const { t: accommodationsTrans } = useTranslation('guestSiteCustom');
  const accTrans = accommodationsTrans('accommodations');

  if (!percentage || percentage === 0) return null;

  return (
    <TextV2
      paddingX={{ _: 2, sm2: 3 }}
      typographyVariant="label3"
      paddingY={pxToRem(4)}
      fontSize={{ _: pxToRem(11), sm2: pxToRem(13) }}
      borderRadius={'full'}
      backgroundColor={'accentGreen2'}
      color={'accentGreen3'}
      width={'fit-content'}
      whiteSpace={'nowrap'}
    >
      {accTrans.percentageOff({ percentage })}
    </TextV2>
  );
};
